import React from 'react';
import TotalTargetBubble from './TotalTargetBubble';
import ActivePortfolioBubbles from './portfolios/ActivePortfolioBubbles';
import PortfoliosProgress from './portfolios/PortfoliosProgress';
import PeriodSelection from './portfolios/PeriodSelection';

const BubbleDesign: React.FC = () => {
    const radiusX = 1015;
    const radiusY = 835
    return <svg width={radiusX} height={radiusY} viewBox={`0 0 ${radiusX} ${radiusY}`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx={radiusX/2} cy={292.5} r={292.5} fill="white" className='mainBubble' />
        <g transform={`translate(${radiusX/2},292.5)`}>
            <TotalTargetBubble />
        </g>
        <g transform={`translate(800,220)`}>
            <ActivePortfolioBubbles />
        </g>
        <g transform={`translate(${radiusX/2},292.5)`}>
            <PortfoliosProgress />
        </g>
        <g transform={`translate(${radiusX/2},50)`}>
            <PeriodSelection />
        </g>
    </svg>
}


export default BubbleDesign;